import { createAction } from 'redux-actions';

import {
  LOAD_PAPERWORK_LIST,
  LOAD_PAPERWORK_LIST_SUCCESS,
  LOAD_PAPERWORK_LIST_ERROR,
} from './type';

//Load list Package
export const loadPaperworkListAction = createAction(LOAD_PAPERWORK_LIST);
export const loadPaperworkListSuccessAction = createAction(
  LOAD_PAPERWORK_LIST_SUCCESS,
);
export const loadPaperworkListErrorAction = createAction(
  LOAD_PAPERWORK_LIST_ERROR,
);
